import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUserInfoDetail as _getUserInfoDetail } from '@/api/login';
export default {
  name: 'EmptyTip',
  props: {
    taskStatus: {
      type: Number,
      default: 2
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      tipMap: {
        // 2 只绑定过自学宝，但尚未学习过，推荐复习数据为空状态  3 学习过，但无当日任务状态  4 学习过，当日任务全部完成状态
        2: '想要使用记忆验证卡片方式进行复习，需要先在页面右上角【输入页码】进行【知识探索】视频或笔记的学习哦！完成学习后，系统将会根据你的学习内容为你专属定制复习计划，快去学习吧!',
        3: '今日还没有待复习的记忆验证卡片哦，可以去学习一下新的知识或者先看看其他的复习内容吧！',
        4: '太棒了！今天的记忆验证卡片你已经全部完成了，学有余力的话也可以看看其他复习内容哦！'
      },
      imgMap: {
        2: 'review_ucan_guide_img.png',
        3: 'review_ucan_hi2.png',
        4: 'review_ucan_zan2.png'
      }
    };
  },
  computed: {
    emptyTipClass: function emptyTipClass() {
      var emptyTipMap = {
        2: 'empty-tip__top',
        3: 'empty-tip__right',
        4: 'empty-tip__left'
      };
      return emptyTipMap[this.taskStatus];
    }
  },
  watch: {
    subjectCode: {
      immediate: true,
      handler: function handler() {
        if (!this.subjectCode) return;
        this.getUserInfoDetail();
      }
    }
  },
  created: function created() {
    this.getUserInfoDetail();
  },
  methods: {
    // 获取用户名
    getUserInfoDetail: function getUserInfoDetail() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userInfo, params, _yield$_getUserInfoDe, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userInfo = JSON.parse(localStorage.getItem('userInfo'));
                params = {
                  uid: userInfo.uid
                };
                _context.next = 4;
                return _getUserInfoDetail(params);

              case 4:
                _yield$_getUserInfoDe = _context.sent;
                status = _yield$_getUserInfoDe.status;
                data = _yield$_getUserInfoDe.data;

                if (!(status !== 1)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                _this.name = data.name;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};